/**
 * Desktop appearance config.
 *
 * Wallpaper: Put your image at portfolio-inner-site/src/assets/desktop-wallpaper.jpg (or .png),
 * then set: wallpaperImage: require('../assets/desktop-wallpaper.jpg')
 * Or put at portfolio-inner-site/public/desktop-wallpaper.jpg and set wallpaperImage: '/desktop-wallpaper.jpg'
 */
export const DESKTOP_CONFIG = {
    wallpaperImage: '/desktop-wallpaper.jpg',
    menuBarHeight: 26,
};

/**
 * Dock (bottom bar) icon size in pixels (width & height).
 * Keys match `DOCK_ORDER` in Desktop.tsx (`separator` is not an app — no entry).
 * `DOCK_DEFAULT_ICON_SIZE` is used only if a dock key is missing from this map.
 */
export const DOCK_DEFAULT_ICON_SIZE = 52;

export const DOCK_ICON_SIZES: Record<string, number> = {
    linkedin: 50,
    calendar: 60,
    github: 56,
    email: 52,
    cursor: 52,
    safari: 52,
    music: 51,
    terminal: 64,
    health: 52,
    credits: 52,
    doom: 52,
    mario: 52,
    pacman: 52,
    quake: 52,
    tetris: 52,
    tron: 52,
    bin: 52,
};
